module.exports = __webpack_public_path__ + "static/media/training.b1853bc1.png";